

export default {
    medusa_backend_url:  import.meta.env.VITE_API_URL,
    //medusa_backend_url: 'http://localhost:9000/',
    STRIPE_API_KEY: 'pk_live_51Q2VAhP6MKKuBFhxZma4343LedGqSN33dgdMtNa4R5y3uktNcrnOe0k4XE5hqmuH0zSQvNJI8DsidycfwoKiVbpr00FoBNHIPz'
}

